module.exports = __webpack_public_path__ + "static/media/whitelogo.10853c1b.png";